import { RefObject, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToHash = <T extends HTMLElement>(
  ref: RefObject<T>,
  hash: string
) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === hash && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location, hash, ref]);
};
